import { styled } from "sharedUI/styles";

export const HelpContainer = styled.div`
    position: fixed;
    right: 20px;
    bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

const HelpButtonSize = 40;

export const HelpButtonStyle = styled.div`
    height: ${HelpButtonSize}px;
    width: ${HelpButtonSize}px;
    border-radius: ${HelpButtonSize / 2}px;
    background-color: ${p => p.theme.bgColorAccent};
    color: ${p => p.theme.fgColorAccent};
    text-align: center;
    font-size: 24px;
    padding-top: 5px;
    transform: scale(0.95);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.15);
    transition: 150ms ease-in-out all;
    cursor: pointer;
    &:hover {
        transform: scale(1);
        background-color: ${p => p.theme.bgColorAccent};
        box-shadow: 0px 7px 15px 0px rgba(0, 0, 0, 0.3);
        cursor: pointer;
    }
`;

export const HelpMenuSeparator = styled.div`
    height: 1px;
    background-color: ${p => p.theme.fgColorMedium};
    margin: 4px 0;
    opacity: 0.2;
`;

export const HelpMenuItemStyle = styled.div`
    font-size: 12px;
    padding: 6px 18px;

    display: flex;
    align-items: center;

    transition: 200ms ease-in-out all;

    &:hover {
        cursor: pointer;
        background-color: ${p => p.theme.bgColorMedium};
    }
`;

export const HelpMenuItemTitleStyle = styled.span`
    flex-grow: 1;
`;

export const HelpMenuStyle = styled.div`
    background-color: ${p => p.theme.bgColorLight};
    color: ${p => p.theme.fgColorDark};
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.15);
    transition: 100ms ease-in-out all;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 10px 0;
`;
